export enum CompanySize {
  SMALL = "SMALL",
  MEDIUM = "MEDIUM",
  LARGE = "LARGE",
  XLARGE = "XLARGE",
}

export enum Status {
  ACTIVE = "active",
  INACTIVE = "inactive",
  DELETED = "deleted",
}

export enum MoneyUnit {
  vnd = "vnd",
  usd = "usd",
}

export enum SortType {
  asc = "asc",
  desc = "desc",
}

export enum PostType {
  normal = "normal",
  special = "special",
  hot = "hot",
}

export enum StatusPurchase {
  pending = "pending",
  success = "success",
  failed = "failed",
  processing = "processing",
}

export enum JobType {
  fullTimeOffice = "fullTimeOffice",
  partTimeOffice = "partTimeOffice",
  fullTimeRemote = "fullTimeRemote",
  partTimeRemote = "partTimeRemote",
  fullTimeHybrid = "fullTimeHybrid",
  partTimeHybrid = "partTimeHybrid",
  freelance = "freelance",
}

export enum Gender {
  male = "male",
  female = "female",
  other = "other",
}

export enum JobStatus {
  active = "active",
  inactive = "inactive",
  deleted = "deleted",
  blocked = "blocked",
}

export enum SortByJobField {
  createdAt = "createdAt",
  updatedAt = "updatedAt",
  closeAt = "closeAt",
  totalApplicants = "totalApplicants",
}
